module.exports = __webpack_public_path__ + "assets/img/close.39111ce5.svg";